<template>
  <svg
    width="24"
    height="24"
    :class="customStyle"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2_50)">
      <path
        d="M2.05001 13H4.06201C4.30604 14.9331 5.24709 16.7107 6.70858 17.9993C8.17008 19.2879 10.0516 19.9989 12 19.9989C13.9485 19.9989 15.8299 19.2879 17.2914 17.9993C18.7529 16.7107 19.694 14.9331 19.938 13H21.951C21.449 18.053 17.185 22 12 22C6.81501 22 2.55101 18.053 2.05001 13ZM2.05001 11C2.55001 5.947 6.81401 2 12 2C17.186 2 21.449 5.947 21.95 11H19.938C19.694 9.0669 18.7529 7.28927 17.2914 6.00068C15.8299 4.71208 13.9485 4.00108 12 4.00108C10.0516 4.00108 8.17008 4.71208 6.70858 6.00068C5.24709 7.28927 4.30604 9.0669 4.06201 11H2.04901H2.05001ZM12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0392 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0392 13.7893 12.5304 14 12 14Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_50">
        <rect
          width="24"
          height="24"
          rx="10"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'GHGIcon',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
